import { PartSmartLoginWindow } from './PartSmartLoginWindow';
import { connect } from 'react-redux';
import {
  dashboardViewActions,
  dashboardViewErrorSel,
  dashboardViewIsPendingSel
} from 'src/store/modules/dashboardview';

const mapStateToProps = (state: any) => {
  return {
    isLoading: dashboardViewIsPendingSel(state),
    hasError: dashboardViewErrorSel(state).hasFailed
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onCurrentPasswordChange: (value: string) =>
    dispatch(dashboardViewActions.setCurrentPassword(value)),
  onUnlockHandleChange: (value: string) =>
    dispatch(dashboardViewActions.setCurrentPassword(value)),
  onNewPasswordChange: (value: string) =>
    dispatch(dashboardViewActions.setNewPassword(value)),
  onNewPasswordRepeatChange: (value: string) =>
    dispatch(dashboardViewActions.setNewPasswordRepeat(value)),
  onChangePassword: (cb?: (result: boolean) => void) =>
    dispatch(dashboardViewActions.changePassword(cb)),
  onClearError: () => dispatch(dashboardViewActions.setError())
});

export const pureComponent = PartSmartLoginWindow;
export default connect(mapStateToProps, mapDispatchToProps)(PartSmartLoginWindow);

interface IDispatchFromProps {
  onCurrentPasswordChange(value: string): void;
  onUnlockHandleChange(value: string): void;
  onNewPasswordChange(value: string): void;
  onNewPasswordRepeatChange(value: string): void;
  onChangePassword(cb?: (result: boolean) => void): void;
  onClearError(): void;
}
